﻿import { AddressSearch, showInvalidAddressWarning, postAddressForValidation, getAddressesForValidation, updateAddresses, processHiddenErrors } from "../../../../Fundraising.UI.Shared/Modules/search/address/AddressSearch";
import { clearFields } from "../../../../Fundraising.UI.Shared/Modules/formTools/util";
import "../scss/personalizedPatch.scss";

(function ($) {
    //Decalare in Global Namespace	
    window.M2 = window.M2 || {};
    window.M2.PersonalizedPatch = {};

    // Private Variables
    var isInIframe = (window.location !== window.parent.location) ? true : false;

    function submitForm(form) {
        $(form).submit();
    }

    const disableSubmission = ($button) => {
        // Disable the buttons immediatly
        $button.addClass('disabled').attr('disabled', 'disabled');
    }
    const enableSubmission = ($button) => {
        // Re-enable the button as we've found suggestions
        $button.removeClass('disabled').removeAttr('disabled');
    }

    function closePatchCallout(ref) {
        ref.$(".patch-callout-content").fadeOut("slow", function (e) {
            ref.$(".close-patch-callout").addClass("hidden");
            ref.$(".patch-callout-msg").show();
            ref.M2.PersonalizedPatch.displayMessaging("cancel");
        });
    }

    function setCancelDialogs() {
        $(document).on("click", ".close-patch-callout, #personalized-patch-overlay .close-patch-overlay", function (e) {
            e.preventDefault();
            var ref;
            if ($(this).hasClass('close-patch-callout')) ref = window;
            else ref = document.getElementById('iframe-personalized-patch-overlay').contentWindow.window;

            if (ref.$("#display-close-button-msg").val() === "True") {
                closePatchCallout(ref);
            } else {
                if (ref === window) {
                    $("#patch-callout-container").slideUp();
                }
                else M2.Modal.hide();
            }
        });

        $(document).on("click", ".btn.go-back", function (e) {
            e.preventDefault();
            $(".patch-callout-msg").fadeOut("slow", function (e) {
                $(".close-patch-callout").removeClass("hidden");
                $(".patch-callout-content").show();
                if (isInIframe) M2.Modal.resizeParentIframe();
            });
        });

        $(document).on("click", ".patch-callout-msg.cancel .btn.confirm, .patch-callout-msg.no-me2-success .btn.confirm", function (e) {
            e.preventDefault();
            $("#patch-callout-container").slideUp();
        });
    }


    function createVerticalText(txt) {
        var characters = txt.split("");
        var newText = "";

        $.each(characters, function (i, el) {
            if (el !== "." && el !== " ") newText += "<span>" + el + "</span>";
            if (el === " ") newText += "<span>&nbsp;</span>";
        });
        return newText;
    }

    function setPatchNamePosition() {

        // Set Selected Name/Position
        var nameOnPatch = $(".name-on-patch").find("option:selected").val();
        var patchType = $("#SelectedAvatarPersonalizedPatchId").find("option:selected").val();
        var patchDataSelector = "#data-patch-name-" + nameOnPatch + "-" + patchType;

        if (nameOnPatch === "NickName") $(patchDataSelector).data("patch-name", $("#NickName").val());

        var name = $(patchDataSelector).data("patch-name");
        var pos = $(patchDataSelector).data("patch-position");
        var axis = $(patchDataSelector).data("patch-axis");
        var fontFamily = $(patchDataSelector).data("patch-font-style");
        var fontColor = $(patchDataSelector).data("patch-color");
        var fontSize = $(patchDataSelector).data("patch-font-size");
        var position = pos.split(',');

        // One of these two points may be centered depending on axis
        var centerX = position[0];
        var centerY = position[1];

        var patchNameY;
        var patchNameX;

        var $patchName = $("#patch-name");
        $patchName.css("visibility", "hidden");


        // Set font family first to avoid mismatch measurements

        $patchName.css({
            fontFamily: fontFamily,
            fontSize: fontSize,
            color: "rgb(" + fontColor + ")"
        });

        if (name.length > 7) $("#patch-name").addClass("smaller-font");
        else $("#patch-name").removeClass("smaller-font");

        if (axis === "Vertical") {
            $("#patch-name").html(createVerticalText(name));
            // Center the Name
            $(".patch-preview #patch-name").width(28);
            patchNameX = position[0];
            patchNameY = centerY - ($patchName[0].getBoundingClientRect().height / 2);
        } else {
            $("#patch-name").html(name);
            patchNameX = centerX - ($patchName[0].offsetWidth / 2);
            patchNameY = position[1];
        }

        $patchName.css({
            top: patchNameY + "px",
            left: patchNameX + "px",
        }).delay(500).css("visibility", "visible");

    }

    const displayPatchEnvelopePreview = ($form) => {
        $form.submit(function (e) {
            var $img = $('<img />', {
                src: M2.Util.config.pathToImages + "loading-bar.gif",
                alt: 'Loading'
            });
            $img.addClass("loading");
            $(".close-patch-callout").addClass("hidden");
            $(".patch-callout-content").addClass("hidden");
            $(".loading-area").html($img);
            $("#personalized-patch-container").css("overflow", "hidden");
        });

        // Display Confirmation
        $(".patch-config").addClass("hidden");
        $(".patch-confirm").removeClass("hidden");

        $("#patch-configurator-copy").addClass("hidden");
        $("#patch-confirmation-copy").removeClass("hidden");

        // Scroll up (hey....)
        $("html, body").animate({ scrollTop: 0 }, "fast");
        if (isInIframe) {
            M2.Modal.resizeParentIframe();
        }

        // Display Shipping Address
        $(".recipient-address .first-name").html($("#FirstName").val());
        $(".recipient-address .last-name").html($("#LastName").val());
        $(".recipient-address .address1").html($("#AddressLine1").val());
        $(".recipient-address .address2").html($("#AddressLine2").val());
        $(".recipient-address .city").html($("#City").val());
        $(".recipient-address .state").html($("#State").val());
        $(".recipient-address .zip").html($("#Zip").val());
        $(".btn.confirm").addClass("hidden");
        $(".btn.submit").removeClass("hidden");
        $(".confirmation-cancel").removeClass("hidden");
        $(".btn.remind-later").addClass("hidden");
    }

    const setPersonalisePatchConfiguratorEvents = () => {
        setPatchNamePosition();

        // Make sure image has loaded
        $('#patch-preview-image').bind('load', function () {
            window.setTimeout(function () {
                setPatchNamePosition();
            }, 200);
        });

        // Live update Nickname Field
        $("#NickName").on('keyup keypress blur change', function (e) {
            const max = M2.PersonalizedPatch.config.nicknameCharacterCount;
            const currentCount = $(this).val().length;

            if (currentCount <= max) setPatchNamePosition();
            else {
                e.preventDefault();
                this.value = this.value.substring(0, max);
            }
        });

        // Remove error message if agreement made
        const switchId = "patch-agree";
        const switchObj = M2.Util.getSwitch(switchId);
        const $switch = $("#" + switchId);

        if (switchObj) {
            switchObj.onChangeSuccess = function (isChecked) {
                if (isChecked) $(".patch-callout-content span.field-validation-error").addClass("hidden");
            }
        }
    }

    function personalizedPatchDialogSetup() {

        if (M2.Util.exists($("select.name-on-patch"))) {
            setPersonalisePatchConfiguratorEvents();
            // On Change for Name Drop Down
            $(document).on("change", ".name-on-patch", function (e) {
                e.preventDefault();

                // Show Nickname if selected
                if ($(this).val() === "NickName") {
                    $(".patch-options .field-grp.nick-name").hide();
                    $(".patch-options").addClass("show-nickname");
                    $(".patch-options .field-grp.nick-name").fadeIn();
                }
                else {
                    $(".patch-options").removeClass("show-nickname");
                    $(".patch-options .field-grp.nick-name").hide();
                }

                if ($(this).val() === "Initials") $("#patch-name").addClass("initials");
                else $("#patch-name").removeClass("initials");

                setPatchNamePosition();
                if (isInIframe) M2.Modal.resizeParentIframe();
            });
            // On Change Patch Style
            $(document).on("change", "#SelectedAvatarPersonalizedPatchId", function (e) {
                e.preventDefault();
                var onPatch = $(this).find("option:selected").val();

                var patchImageSelector = "#data-patch-image-" + onPatch;
                const patchImageSrc = $(patchImageSelector).data("patch-image");

                $("#patch-preview-image").attr("src", patchImageSrc);
            });
            // Submission Confirmation
            $(document).on("click", ".patch-callout-content .btn.confirm", function (e) {
                e.preventDefault();
                const $button = $(this);
                const validationAddressUrl = $button.data("validate-address-url");
                const $form = $button.closest("form");
                const token = $form.find("input[name='__RequestVerificationToken']").val();
                const $patchConfirmSwitch = $("#patch-agree");
                const $patchConfirmSwitchError = $(".patch-callout-content span.field-validation-error");

                if ($form.valid() && $patchConfirmSwitch.prop('checked')) {
                    disableSubmission($button);
                    // Validate Addresse First
                    const data = {
                        "": getAddressesForValidation(),
                        "__RequestVerificationToken": token,
                    }

                    postAddressForValidation(validationAddressUrl, data).done((addresses) => {
                        const invalidAddresses = [];
                        const validAddresses = [];
                        let hasPOBox = false;
                        addresses.forEach(function (address, i) {
                            const valid = address.valid;
                            const poBoxWarning = address.poBoxWarning;
                            address.index = i;

                            if (poBoxWarning) {
                                hasPOBox = true;
                            }
                            else if (valid) {
                                validAddresses.push(address);
                            } else {
                                invalidAddresses.push(address);
                            }
                        });

                        if (hasPOBox) {
                            M2.Modal.create("poBoxError", "Attention", "#pobox-alert", "modal-xs", true);
                            enableSubmission($button);
                        }
                        else if (invalidAddresses.length) {
                            showInvalidAddressWarning(invalidAddresses);
                            enableSubmission($button);
                        } else {
                            updateAddresses($(".shipping-address-container"), validAddresses, () => {
                                displayPatchEnvelopePreview($form);
                            });
                        }
                    });
                } else {

                    if (!$patchConfirmSwitch.prop('checked')) {
                        $patchConfirmSwitchError.removeClass("hidden");
                    } else {
                        $patchConfirmSwitchError.addClass("hidden");                   
                        const $invalidFields = $(".address-fields .input-validation-error");
                        processHiddenErrors($invalidFields);
                    }
                    // Scroll up (hey....)
                    $("html, body").animate({ scrollTop: 0 }, "fast");
                    if (isInIframe) {
                        M2.Modal.resizeParentIframe();
                    }
                    return false;
                }
            });
            // Cancel Confirmation Submission
            $(document).on("click", ".patch-callout-content .btn.confirmation-cancel", function (e) {
                // Hide Confirmation / Revert Form
                $(".patch-config").removeClass("hidden");
                $(".patch-confirm").addClass("hidden");

                $("#patch-configurator-copy").removeClass("hidden");
                $("#patch-confirmation-copy").addClass("hidden");
                $(".confirmation-cancel").addClass("hidden");
                $(".btn.confirm").removeClass("hidden");
                $(".btn.submit").addClass("hidden");
                $(".btn.remind-later").removeClass("hidden");

                const $submitBtn = $(".btn.confirm");
                enableSubmission($submitBtn)

                // Scroll up (hey....)
                $("html, body").animate({ scrollTop: 0 }, "fast");
                if (isInIframe) {
                    window.parent.$("html, body").animate({ scrollTop: 0 }, "fast");
                    M2.Modal.resizeParentIframe();
                }
            });
        }
    }

    const setAddressSearch = () => {
        const ShippingAddressSearch = new AddressSearch(".address-autocomplete", {
            apiKey: "195948433105312307",
            lookupAddressUrl: "https://us-autocomplete-pro.api.smarty.com/lookup?",
            suggestionDelay: 300
        });

        ShippingAddressSearch.onOpen((searchInput) => {
            const $shippingAddressContainer = $(searchInput).closest(".shipping-address-container");
            $shippingAddressContainer.attr("data-view-mode", "searching");
            const $addressSuggestionRequired = $shippingAddressContainer.find(".address-search-required");
            $addressSuggestionRequired.val("False");
        });

        ShippingAddressSearch.onSelect((data, searchInput) => {
            const { address1, address2, city, state, zip } = data;
            const $shippingAddressContainer = $(searchInput).closest(".shipping-address-container");
            $shippingAddressContainer.attr("data-view-mode", "found");
            const $addressLine1 = $shippingAddressContainer.find(".address input[type='text']");
            const $addressLine2 = $shippingAddressContainer.find(".address2 input[type='text']");
            const $city = $shippingAddressContainer.find(".city input[type='text']");
            const $state = $shippingAddressContainer.find(".state select");
            const $zip = $shippingAddressContainer.find(".zip input[type='text']");

            $addressLine1.val(address1);
            $addressLine2.val(address2);
            $city.val(city);
            $state.val(state);
            $zip.val(zip);
        });

        $(document).on("click", ".find-another-address a", (e) => {
            e.preventDefault();
            const $shippingAddressContainer = $(e.currentTarget).closest(".shipping-address-container");
            clearFields($shippingAddressContainer);
            $shippingAddressContainer.attr("data-view-mode", "search");
            const $addressSuggestionRequired = $shippingAddressContainer.find(".address-search-required");
            $addressSuggestionRequired.val("True");
        });

        $(document).on("click", ".dont-see-address a", (e) => {
            e.preventDefault();
            const $shippingAddressContainer = $(e.currentTarget).closest(".shipping-address-container");
            clearFields($shippingAddressContainer);
            $shippingAddressContainer.attr("data-view-mode", "found");
            const $addressSuggestionRequired = $shippingAddressContainer.find(".address-search-required");
            $addressSuggestionRequired.val("False");
        });
    }

    const setValidateAddressTools = () => {
        const $invalidAddress = $("#InvalidAddress");
        $(document).on("click", ".confirm-unverified-address", function (e) {
            e.preventDefault();
            $invalidAddress.val("True");
            M2.Modal.close();
            displayPatchEnvelopePreview($("#config-patch-form"));
        });

        $(document).on("click", ".re-enter-address", function (e) {
            e.preventDefault();
            $invalidAddress.val("False");
            M2.Modal.close();
        });
    }

    M2.PersonalizedPatch = {
        config: {
            name: "M2 Personalized Patch",
            nicknameCharacterCount: 10,
            patchNameLeftPosition: 26
        },
        init: function () {
            setCancelDialogs();
            personalizedPatchDialogSetup();
            setAddressSearch();
            setValidateAddressTools();
        },
        savePatchAddressOnSuccess: function (result) {
            const successFlag = $("#hidden-success").val();
            const isLaunchPage = $("body.participant-setup").length || $(".inner-content.hold").length;

            if (successFlag !== "False") {
                if ($(".patch-callout-content").hasClass("no-avatar")) {
                    $(".patch-callout-content").fadeOut("slow", function (e) {
                        M2.PersonalizedPatch.displayMessaging("no-avatar-save");
                    });
                }
                else {

                    if (isLaunchPage) {
                        $(".patch-callout-content").fadeOut("slow", function (e) {
                            $("#patch-callout-container").slideUp("slow");
                        });
                    } else {
                        M2.Util.successMsg();
                        M2.Util.setSwitches();
                        setPersonalisePatchConfiguratorEvents();
                    }
                }
            }
        },
        displayMessaging: function (method) {
            if (method === "cancel") $(".patch-callout-msg").removeClass("no-me2-success").addClass("cancel");
            if (method === "no-me2-save") $(".patch-callout-msg").removeClass("cancel").addClass("no-me2-success");
            if (isInIframe) M2.Modal.resizeParentIframe();
        }
    }
})(jQuery);

$(function () {
    M2.PersonalizedPatch.init();
});